/* @flow */
import { em } from 'polished';
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  modalContent: {
    padding: 0,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: em(32),
    paddingBottom: em(32),
  },
  rootContent: {
    display: 'flex',
  },
  content: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'left',
    padding: 35,
    width: ({ hasUnwrapitGift }: ThemeFunction<{ hasUnwrapitGift: boolean }>) =>
      hasUnwrapitGift ? '50%' : '100%',
  },
  contentCentered: {
    textAlign: 'center',
  },
  congratulations: {
    fontWeight: 700,
    fontSize: em(40),
    textAlign: 'left',
    marginBottom: em(15),
    color: ({ theme }: ThemeFunction) => theme.accentColor,
  },
  topicTitle: {
    color: ({ theme }: ThemeFunction) => theme.textColor,
    fontSize: em(24),
    margin: `${em(8)} 0 !important`,
  },
  description: {
    fontWeight: 500,
    fontSize: em(17),
    margin: '0 !important',
    color: ({ theme }: ThemeFunction) => theme.accentColor,
  },
  centered: {
    textAlign: 'center',
  },
  descriptionSeparatorContainer: {
    margin: '10px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  descriptionSeparator: {
    display: 'block',
    width: '50%',
    height: em(1),
    backgroundColor: ({ theme }: ThemeFunction) => theme.accentColor,
  },
  descriptionHighlight: {
    color: ({ theme }: ThemeFunction) => theme.textColor,
  },
  smallDescription: {
    margin: '0 !important',
  },
  smallDescriptionHighlight: {
    fontWeight: 700,
  },
  message: {
    position: 'relative',
    maxWidth: 350,
    padding: 15,
    margin: `${em(35)} ${em(0)} 0 ${em(8)} !important`,
    borderRadius: 6,
    fontStyle: 'italic',
    backgroundColor: ({ theme }: ThemeFunction) => theme.colorBase,
  },
  quote: {
    position: 'absolute',
    width: em(25),
    height: em(23),
    color: ({ theme }: ThemeFunction) => theme.accentColor,
  },
  quoteIn: {
    top: em(-9),
    left: em(-7),
  },
  quoteOut: {
    bottom: em(-6),
    right: em(-5.5),
    transform: 'rotate(180deg)',
  },
  contentSeparator: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: em(1),
    minHeight: '100%',
  },
  separator: {
    width: em(1),
    height: '70%',
    backgroundColor: ({ theme }: ThemeFunction) => theme.accentColor,
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    with: '100%',
    paddingTop: em(28),
  },
  unwrapitGiftIconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  unwrapitGiftIcon: {
    color: ({ theme }: ThemeFunction) => theme.accentColor,
  },
};
